export const TITLE_SUCCESS = "Success";
export const TITLE_FAILURE = "Failure";
export const MESSAGE_PROFILE_UPDATE_SUCCESS = "Profile image updated successfully";
export const MESSAGE_PROFILE_UPDATE_FAILURE = "Something went wrong, please try again";

export const VIEW_TYPE_DEFAULT = 'default';
export const VIEW_TYPE_COMFY = 'comfy';